<ion-row>
  <ion-col size="12">
    <div class="bold-text intro-title top-title">
      <ion-label>{{content?.user?.components?.meetAmo?.componentIntroTitle}}</ion-label>
    </div>
  </ion-col>
</ion-row>
<ion-row class="ion-align-items-center">
  <div class="intro card-1 clearfix">
    <ion-col size="6" size-xl="6" size-lg="6" size-md="12" size-sm="12" size-xs="12">
      <div>
        <img src="/img/AMOSupportTeam.png">
      </div>
    </ion-col>
    <ion-col size="6" size-xl="6" size-lg="6" size-md="12" size-sm="12" size-xs="12">
      <p class="body">
        <span class="bold-text">{{content?.user?.components?.meetAmo?.cardContent?.boldContent.text1}}</span>
        {{content?.user?.components?.meetAmo?.cardContent?.meetAmoMainContent?.topInvite}}<br><br>
        {{content?.user?.components?.meetAmo?.cardContent?.meetAmoMainContent?.midInvite}}<br><br>
        {{content?.user?.components?.meetAmo?.cardContent?.meetAmoMainContent?.bottomInvite}}
      </p>
    </ion-col>
  </div>
</ion-row>
<ion-row>
  <ion-col size="12">
    <div class="bold-text intro-title top-title">
      <br />
      <ion-label>{{content?.user?.components?.meetAmo?.componentTitleBottom}}</ion-label>
    </div>
  </ion-col>
</ion-row>
<ion-row>
  <div class="intro card-1 clearfix">
    <ion-col size="12">
      <div class="card-container">
        <p class="body">
          <span class="bold-text">{{content?.user?.components?.meetAmo?.cardContent?.boldContent?.text2}}</span>
          {{content?.user?.components?.meetAmo?.cardContent?.coachesTopContent}}
        </p>
        <div class="videos-section">
          <div class="videos-container">
            <div class="videos">
              <a href="https://www.youtube.com/embed/Q3p0dY-Na5E" target="_blank">
                <ion-img src="assets/coach_jordan.webp"></ion-img>
                <br>
                <ion-text>Watch Now</ion-text>
              </a>
            </div>
            <div class="videos">
              <a href="https://www.youtube.com/embed/qRHuhRT8HV4" target="_blank">
                <ion-img src="assets/coach_ashley.webp"></ion-img>
                <br>
                <ion-text>Watch Now</ion-text>
              </a>
            </div>
          </div>
        </div>
        <div class="faq-title">
          <ion-label>{{content?.user?.components?.meetAmo?.cardContent?.boldContent?.text3}}</ion-label>
        </div>
        <div *ngFor="let item of content.user.components.meetAmo.cardContent.faqContent.questionList">
          <p class="body">{{item}}</p>
        </div>
      </div>
    </ion-col>
  </div>
</ion-row>